module.exports = __webpack_public_path__ + "img/ebook.e609fa82.png";